module.exports = {"confirm_nationality":"Confirm your nationality","hint":"Your passport country","other":"Other nationality","nationality":"Nationality"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/nationality.json
// module id = 529
// module chunks = 245 967